import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridEventListener, GridEvents } from "@mui/x-data-grid-pro";

import { COLLECTION_YARDS_PAGE_PATH } from "../../../middleware/routes";
import {
  cleanUpCollectionPointDetail,
  getCollectionPointDetailThunk,
  setCollectionPoint,
} from "../../../reducers/collectionPointReducer";
import { buildCollectionPointUrl } from "../../../utils/url";
import { CollectionPointPageTab } from "../../CollectionPointPage";

interface CollectionYardsTableHandlers {
  handleAdditionalRowClick: GridEventListener<GridEvents.rowClick>;
}

export const useGetCollectionYardsTableHandlers = (): CollectionYardsTableHandlers => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleAdditionalRowClick: GridEventListener<GridEvents.rowClick> = (params) => {
    const collectionPointId = params.row.locationId;
    dispatch(cleanUpCollectionPointDetail());
    dispatch(setCollectionPoint(params.row));
    dispatch(getCollectionPointDetailThunk(collectionPointId));

    history.push(
      buildCollectionPointUrl(collectionPointId, {
        prevPage: COLLECTION_YARDS_PAGE_PATH,
        tab: CollectionPointPageTab.CollectionYardVisits,
      })
    );
  };

  const collectionYardsTableHandlers: CollectionYardsTableHandlers = {
    handleAdditionalRowClick,
  };

  return collectionYardsTableHandlers;
};
